import React, { Component, Fragment } from "react";

export default class Error extends Component {

  routeUser = () => {
    if (this.props.user) {
      this.props.handleRouting();
    } else {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12 margin-bottom-container center">
            <h4 className="muted">Ut oh. We're having a problem connecting to your account.</h4>
            <h4 className="muted">
              Please make sure you're online and/or <button onClick={() => {
                this.routeUser();
              }} className="btn-plain-text muted h4">click here to retry.</button>
            </h4>
            <br/>
            <h5 className="muted">If you continue to see this page, please <a className="muted h5" href="https://www.givevolunteers.org/contact/" target="_new">contact us.</a></h5>
          </div>
        </div>
      </Fragment>
    )}
}